import State from "../state"

export const getOnboardingPlacement = (state: State): number =>
  state.onboarding.placement
